export default __webpack_public_path__ + "static/media/calendar.fc14629f.svg";